import BaseModel from "../BaseModel";
import SampleTest from './SampleTest';
import SampleType from './SampleType';
import SampleCertType from './SampleCertType';
import SampleNote from './SampleNote'
import Customer from './Customer'
import ReleaseQueue from "./ReleaseQueue";
import SampleFlag from "@/Store/ORM/SampleFlag";
import Name from "@/Store/ORM/Name";

export default class Sample extends BaseModel {
    static entity = 'samples';
    static primaryKey = "uuid";
    static fields(){
        return {
            uuid: this.attr(null),
            id: this.attr(null),
            name: this.attr(null),
            customer_id: this.attr(null),
            customer_name_id: this.attr(null),
            manifest_id: this.attr(null),
            order_id: this.attr(null),
            is_rnd: this.attr(null),
            sample_type_uuid: this.attr(null),
            sample_type_name: this.attr(null),
            sample_cert_type_uuid: this.attr(null),
            requirements: this.attr(null),
            required_tests: this.attr([], value => {
                if(Array.isArray(value)){
                    return value
                }
                return Object.values(value);
            }),
            legal_type: this.attr(null),
            qa: this.attr(null),
            lot: this.attr(null),
            harvest_date: this.attr(null),
            weight: this.attr(null),
            serving_weight: this.attr(null),
            unit_uuid: this.attr(null),
            qa_approved: this.attr(null),
            billing_approved: this.attr(null),
            is_released: this.attr(null),
            created_by: this.attr(null),
            updated_by: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            releasing: this.attr(false),
            meta_data: this.attr(false),

            //Relations
            customer: this.hasOne(Customer, 'id', 'customer_id'),
            names: this.hasMany(Name, 'customer_id', 'customer_id'),
            assigned_name: this.hasOne(Name, 'id', 'customer_name_id'),
            sample_tests: this.hasMany(SampleTest, 'sample_uuid'),
            sample_type: this.belongsTo(SampleType, "sample_type_uuid"),
            sample_cert_type: this.belongsTo(SampleCertType, "sample_cert_type_uuid"),
            sample_notes: this.hasMany(SampleNote, "sample_uuid"),
            release_queue: this.hasOne(ReleaseQueue, 'sample_uuid'),
            sample_flags: this.hasMany(SampleFlag, 'sample_uuid')
        }
    }

    get sample_lab_type_name(){
        let type = SampleType.find(this.sample_type_uuid);
        if(type){
            return type.name;
        }
        return 'UNSELECTED'
    }

    get short_id(){
        if(/[A-Z]{2}-\d{6}-\d+/g.test(this.id)){
            return this.id.replace(/([A-Z]{2}-)/g, '');
        }
        return this.id
    }

    get iso_id(){
        if(/[A-Z]{2}-\d{6}-\d+/g.test(this.id)){
            return this.id.replace(/([A-Z]{2}-)|-/g, '');
        }
        return this.id
    }

    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'unit', 'sample_tests', 'sample_type', 'sample_cert_type', 'sample_notes']
    }

    static name(){
        return "Sample"
    }

    static route(){
        return process.env.VUE_APP_RECORDED_API + '/samples';
    }

    static apiConfig = {
        ...super.apiConfig,
        headers: {
            "Accept": "application/json",
            "Authorization": process.env.VUE_APP_RECORDED_API_KEY,
            "VueRoute": window.location.href,
        }
    }
}
